module.exports = __webpack_public_path__ + "static/media/video.ed108ed3.png";